module.exports = __webpack_public_path__ + "img/phone-blue.4616f66.svg";